import { useEffect, useState } from "react";

export interface GoogleReview {
  author: string;
  rating: number;
  text: string;
  relativeTime?: string;
}

export interface GoogleRating {
  rating: number | null;
  total: number;
  mapsUrl: string | null;
  reviews: GoogleReview[];
}

/**
 * Fetches the live Google Business rating via the /api/google-rating
 * serverless function. Fails silently (rating stays null) — the API doesn't
 * exist during local prerendering or `npx serve`, and consumers simply hide.
 */
export const useGoogleRating = (): { data: GoogleRating | null; loading: boolean } => {
  const [data, setData] = useState<GoogleRating | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetch("/api/google-rating")
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (active && json && typeof json.rating === "number") {
          setData(json as GoogleRating);
        }
      })
      .catch(() => {
        /* silently unavailable */
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { data, loading };
};

export default useGoogleRating;
